import Link from "next/link";

export default function FreeGameCom(props) {
  return (
    <div className="free_games">
      <div className="free_con_1">
        <div className="free_thumb">
          <img
            className="free_img"
            src={props.thumb}
          ></img>
        </div>
        <div className="game_links">
          <h2>{props.title}</h2>
          <div className="dis-liks">
            <div className="dis-head">
              URL :
              <Link href={props.iframe}>
                <a target="_blank">{props.iframe}</a>
              </Link>
            </div>
          </div>
          <div className="dis-liks">
            <div className="dis-head">
            Walkthrough:
              <Link href={props.Walkthrough}>
                <a><span>{props.Walkthrough}</span></a>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="free_con_2">
        <div className="dis-head">Description: </div>
        <div className="dis-text">{props.dis}</div>
      </div>
    </div>
  );
}
